import React, { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CookieConsent from "./CookieConsent";

const LazyHome = lazy(() => import("./Home"));
const LazyPrivacyPolicy = lazy(() => import("./PrivacyPolicy"));
const LazyAccessibility = lazy(() => import("./Accessibility"));

function App() {
  return (
    <Router>
      <div className="w-full min-h-screen bg-brand-white">
        <Helmet>
          <title>
            קונטרה | עיסוי מקצועי בגישה הוליסטית | שוודי, רפואי וכוסות רוח | תל
            אביב
          </title>
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://contra-t.co.il" />
          <meta
            property="og:image"
            content="https://contra-t.co.il/pub-og-img.jpg"
          />
          <meta
            property="og:image:secure_url"
            content="https://contra-t.co.il/pub-og-img.jpg"
          />
          <meta
            property="og:image:alt"
            content="קונטרה - עיסוי מקצועי בגישה הוליסטית"
          />

          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="he_IL" />
          <meta property="og:site_name" content="קונטרה | עיסוי מקצועי" />
          <meta
            name="description"
            content="טיפולי עיסוי מקצועיים בתל אביב בגישה הוליסטית המחברת בין גוף לנפש. שחרור מתחים, טיפול בכאבים וחיבור לאיזון פנימי. קבעו תור עכשיו!"
          />
          <meta
            name="keywords"
            content="עיסוי, מסאג', טיפול, קונטרה, עיסוי שוודי, עיסוי רפואי, כוסות רוח, שחרור מתחים, תל אביב, ניצן, חיבור גוף נפש, הוליסטי"
          />
          <meta
            property="og:title"
            content="קונטרה | עיסוי מקצועי בגישה הוליסטית"
          />
          <meta
            property="og:description"
            content="טיפולי עיסוי מקצועיים המחברים בין גוף לנפש. Every BODY is a teacher - טיפול אישי מותאם לצרכים שלך."
          />

          {/* Twitter Card data */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="קונטרה | עיסוי מקצועי בגישה הוליסטית"
          />
          <meta
            name="twitter:description"
            content="טיפולי עיסוי מקצועיים המחברים בין גוף לנפש. Every BODY is a teacher - טיפול אישי מותאם לצרכים שלך."
          />
          <meta
            name="twitter:image"
            content="https://contra-t.co.il/pub-og-img.jpg"
          />

          {/* Favicon */}
          <link rel="icon" type="image/x-icon" href="/favicon.ico" />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link rel="manifest" href="/site.webmanifest" />

          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "HealthAndBeautyBusiness",
                "name": "קונטרה - עיסוי מקצועי",
                "image": "https://contra-t.co.il/pub-og-img.jpg",
                "telephone": "+972-59-944-0202",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "בן יהודה 49",
                  "addressLocality": "תל אביב",
                  "addressRegion": "תל אביב",
                  "postalCode": "6340302",
                  "addressCountry": "IL"
                },
                "url": "https://contra-t.co.il",
                "priceRange": "₪₪",
                "openingHours": "Mo-Th 08:00-19:00",
                "serviceType": ["עיסוי שוודי", "עיסוי רפואי", "טיפול בכוסות רוח"],
                "sameAs": [
                  "https://www.facebook.com/share/16axaS58sB/",
                  "https://www.instagram.com/nitzan_shacham/"
                ]
              }
            `}
          </script>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="true"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;600;700&family=Secular+One&display=swap"
            rel="stylesheet"
          />

          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-9T1SQ9M7PH"
          ></script>
          <script>
            {`  window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', 'G-9T1SQ9M7PH');
            `}
          </script>
          <script
            src="https://cdn.userway.org/widget.js"
            data-account="JPpfHaOxuo"
          ></script>
        </Helmet>
        <Suspense fallback={<div className="loading">טוען...</div>}>
          <Routes>
            <Route path="/" element={<LazyHome />} />
            <Route path="/privacy-policy" element={<LazyPrivacyPolicy />} />
            <Route path="/accessibility" element={<LazyAccessibility />} />
          </Routes>
          <CookieConsent />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
